export default {
  props: {},
  data() {
    return {
      color: '#333333',
      fontfamily: 'Microsoft Yahei',
      fontfamilyoptions: [{
        label: '微软雅黑',
        value: 'Microsoft Yahei'
      }],
      fontstyle: 'normal',
      fontstyleoptions: [{
        label: '常规体',
        value: 'normal'
      }]
    };
  },
  mounted() {},
  methods: {}
};